import {makeAutoObservable} from 'mobx'
import ProviderModel from "@model/ProviderModel";
import AccomodationModel from "@model/AccomodationModel";
import CateringModel from "@model/CateringModel";
import TransportationModel from "@model/TransportationModel";
import _ from "lodash";

export default class VoucherModel {
    constructor() {
        makeAutoObservable(this)
    }

    value = ''
    type = ''
    uuid = ''
}
